import { FC, PropsWithChildren } from 'react';
import './loader.scss';

type LoaderProps = PropsWithChildren<{
  id?: string;
  className?: string;
  loading: boolean;
  scale?: string;
  /** Optional text under the spinner, for waits long enough that the operator needs to know why. */
  label?: string;
}>;
const Loader: FC<LoaderProps> = ({ children, className, id, loading, scale, label }) => {
  return (
    <div id={id} style={{ position: 'relative' }} className={className}>
      {loading && (
        <div className="loader">
          <svg>
            <circle style={{ scale: scale }} r={20} cx={'50%'} cy={'50%'}></circle>
          </svg>
          {label && <span className="loader-label">{label}</span>}
        </div>
      )}
      {children}
    </div>
  );
};

export default Loader;
